import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/pdf-page-v2.0.0'

export default reactNode(
	'PdfPage',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: true, docs: '' }
)
